import { render, staticRenderFns } from "./BriqTimeInput.vue?vue&type=template&id=13ea27d5&lang=pug&"
import script from "./BriqTimeInput.vue?vue&type=script&lang=js&"
export * from "./BriqTimeInput.vue?vue&type=script&lang=js&"
import style0 from "./BriqTimeInput.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports